import { createReducer } from 'helpers/redux';
// import { } from 'lodash';

export const namespace = 'loading';

const SHOW = 'vtn/loading/SHOW';
const HIDE = 'vtn/loading/HIDE';

const defaultState = 0;

const reducer = createReducer(defaultState, {
  [SHOW](state) {
    return state + 1;
  },

  [HIDE](state) {
    return state - 1;
  }
});

export default reducer;

function local(state) {
  return state[namespace];
}

export function showLoading() {
  return {
    type: SHOW
  };
}

export function hideLoading() {
  return {
    type: HIDE
  };
}

export function isLoading(state) {
  return local(state) > 0;
}



// WEBPACK FOOTER //
// ./src/client/modules/loading/index.js